module.exports = __webpack_public_path__ + "img/icono-experiencia-2.80e49ff6.svg";